<template>
	<div class="knd-paragraph knd-wrapper-md">
		<div class="knd-intro knd-wrapper-text">
			<h3>{{ companyName }} investeert in deze typen projecten:</h3>
		</div>

		<div v-for="(item, index) in items" :key="'risk-' + index" class="risico-item mb-sm">
			<Project :item="item" />
		</div>

	</div>

</template>

<script setup>
	import { ref, computed } from 'vue'
	import { useStore } from 'vuex';
	import Project from './project.vue';

	const store = useStore()
	
  const items = computed(() => store.getters.projects_risk_benefit);
  const companyName = computed(() => store.getters.selectedCompanyName);

</script>

<style lang="scss">
	.risico-item {
		&:last-of-type {
			margin-bottom: 0;
		}
	}
</style>